import {
  ChallengeShell,
  ChoiceGrid,
  useChoices,
  usePickHandler,
  type ChallengeProps,
} from "./shared";

/** See a picture, pick the matching English word. */
export function ImageToWord({ word, distractors, onAnswer }: ChallengeProps) {
  const { picked, handle, teachOverlay, celebrateOverlay, retryKey } = usePickHandler(word, onAnswer);
  const choices = useChoices(word, distractors, retryKey);

  return (
    <>
      <ChallengeShell
        tag="Picture word"
        imageUrl={word.imageUrl}
        imageLabel={word.english}
        prompt="What is this in English?"
        speakerText={word.english}
        speakerAudioUrl={word.audioUrl}
        speakerVietnamese={word.vietnamese}
      >
        <ChoiceGrid
          choices={choices}
          correctId={word.id}
          picked={picked}
          onPick={handle}
          render={(c) => <span className="choice-vi">{c.english}</span>}
        />
      </ChallengeShell>
      {teachOverlay}{celebrateOverlay}
    </>
  );
}
